import script from "./noticeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./noticeItem.vue?vue&type=script&setup=true&lang=js"

import "./noticeItem.vue?vue&type=style&index=0&id=23b4dac2&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23b4dac2"]])

export default __exports__